module.exports = __webpack_public_path__ + "img/jia_normal.14d28106.png";